import { ChangeEvent, useContext, useEffect, useState } from "react";
import { AppContext } from "../../appContext/AppContext";
import InputSearch from "../../component/InputSearch";
import { TablePagination } from "../../component/table/components/TablePagination";
import { TableCustom } from "../../component/table/table-custom/TableCustom";
import TextField from "../../component/TextField";
import {
  CODE,
  DEFAULT_PAGE_INDEX,
  KEY,
  SELECTION_MODE,
  TYPE_WH,
  WF_TRACKER
} from "../../utils/Constant";
import { handlePagesChange, handleRowsPerPageChange, rowsForPage } from "../../utils/PageUtils";
import "../PhanHeNhapKho.scss";
import { withBarcodeScan } from "@oceantech/oceantech-ui";
import { DanhSachPhieuChungColumns } from "../../phan-he-nhap-kho/constants/ColumnsNhapKho";
import { formatDateFromDTOCustom, formatDateToDTOCustom } from "../../utils/FormatUtils";
import { getSummaryStatusByType } from "../../workflows/services/WfWorkflowsService";
import { searchPhieuNhapKhoChung } from "../../phan-he-nhap-kho/services/services";
import ButtonIn from "../../component/button-in-phieu";
interface Props {
  LST_WAREHOUSE: any;
  warehouseId: any;
  className?: any;
  typeKho?: any;
  barcode?: any
};

export const FormXuatKho = (props: Props) => {
  const { warehouseId, typeKho, className, LST_WAREHOUSE, barcode = "" } = props;
  const [dsPhieuNhapKho, setDsPhieuNhapKho] = useState<any[]>([]);
  const [dsPhieuIn, setDsPhieuIn] = useState<any[]>([]);
  const [summaryStatus, setSummaryStatus] = useState<any>([]);
  const [searchData, setSearchData] = useState<any>();
  const [rowsPerPage, setRowsPerPage] = useState<number>(20);
  const [page, setPage] = useState<number>(DEFAULT_PAGE_INDEX);
  const [configTable, setConfigTable] = useState<any>({
    totalPages: 0,
    totalElements: 0,
    numberOfElements: 0,
  });
  const { setIsLoading } = useContext(AppContext);



  const handleChangeSearchData = (e: ChangeEvent<HTMLInputElement>) => {
    setSearchData({
      ...searchData,
      [e.target.name]: e.target.value,
    });
  };



  useEffect(() => {
    setSearchData({
      ...searchData,
      keyword: barcode
    })
    updatePageData(barcode);
  }, [barcode]);


  const updatePageData = async (keySearch?: any) => {
     if (!warehouseId) return
    try {
      setIsLoading(true);
      const { data } = await searchPhieuNhapKhoChung({
        ...searchData,
        warehouseExportType: null,
        keyword: searchData?.keyword ? searchData?.keyword?.trim() : keySearch || null,
        doCreationFromDate: formatDateFromDTOCustom(searchData?.doCreationFromDate),
        doCreationToDate: formatDateToDTOCustom(searchData?.doCreationToDate),
        typeList: [2, 3, 8, 19, 16, 6],
        pageSize: rowsPerPage,
        pageIndex: page,
        warehouseId: warehouseId
      });
      const resSummary = await getSummaryStatusByType(
        WF_TRACKER.NHAP_KHO,
        TYPE_WH.IMPORT,
        {
          warehouseExportType: null,
          warehouseId: warehouseId,
          fromDate: formatDateFromDTOCustom(searchData?.doCreationFromDate) || null,
          toDate: formatDateToDTOCustom(searchData?.doCreationToDate) || null,
        }
      );
      if (CODE.SUCCESS === resSummary.data?.code) {
        setSummaryStatus(resSummary.data.data);
      };
      if (CODE.SUCCESS === data.code) {
        setDsPhieuNhapKho(data?.data?.content || []);
        setConfigTable({
          totalPages: Math.ceil(data.data.pageable.totalElements / data.data.pageable.pageSize),
          totalElements: data?.data?.pageable?.totalElements,
          // numberOfElements: data?.data?.pageable?.pageNumber,
        })
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    updatePageData();

  }, [rowsPerPage, page, warehouseId]);

  const handlerSearchKeyWorld = () => {
    setPage(DEFAULT_PAGE_INDEX);
    setRowsPerPage(20);
    updatePageData()
  }

  const handlerPrintPhieu = (rowData?: any, checked?: boolean) => {
    if (checked) {
      setDsPhieuIn((prev) => [...prev, rowData]);
    } else {
      setDsPhieuIn((prev) => prev.filter((item: any) => item?.id !== rowData?.id));
    }
  };

  useEffect(() => {
    setDsPhieuIn([]);
  }, [page]);


  return (
    <div className="bg-white h-100">
      <div className="flex-1 flex flex-column">
        <div className="d-flex bg-gray ">
          <div className="spaces width-100 bg-gray radius-2">
            <div className="flex bg-white spaces width-100 " >
              <h4 className="text-title text-pri fw-bold fs-4 spaces mb-0 px-10 min-w-180">
                Danh sách phiếu
              </h4>
            </div>
            <div className="d-flex  mt-1 flex-column spaces width-100 ">
              <div className="bg-white">
                <div className="d-flex spaces pr-8 mt-6 bg-white justify-content-between align-items-center mb-6">
                  <div className="d-flex spaces mx-10 ">
                    <ButtonIn
                      disabled={!dsPhieuIn?.length}
                      className="spaces min-w-120 mx-3"
                      endpoint={`api/download/word/warehouse-issue-slip-list`}
                      params={{
                        slipIds: dsPhieuIn?.map((item: any) => item?.id) || [],
                        exportType: "pdf"
                      }}
                    />
                  </div>
                  <div className="d-flex spaces mx-10 ">
                    <TextField
                      label="Từ ngày"
                      name="doCreationFromDate"
                      type="date"
                      value={searchData?.doCreationFromDate || ''}
                      className="flex"
                      labelClassName="spaces mt-5 mr-5"
                      onChange={handleChangeSearchData}
                    />
                  </div>
                  <div className="d-flex spaces mr-10">
                    <TextField
                      label="Đến ngày"
                      name="doCreationToDate"
                      type="date"
                      className="flex"
                      value={searchData?.doCreationToDate || ''}
                      labelClassName="spaces mt-5 mr-5"
                      onChange={handleChangeSearchData}
                    />
                  </div>
                  <div className="flex-grow-1 ">
                    <InputSearch
                      name="keyword"
                      value={searchData?.keyword || ''}
                      placeholder="Tìm kiếm theo mã phiếu"
                      handleChange={handleChangeSearchData}
                      handleSearch={() => handlerSearchKeyWorld()}
                      handleKeyDown={(e: React.KeyboardEvent) => e.key === KEY.ENTER && handlerSearchKeyWorld()}
                      className="spaces h-31 pr-4 radius-3"
                    />
                  </div>
                </div>
                <div className="spaces bg-white mb-0">
                  <TableCustom<any>
                    className={`spaces ${className ? className : "h-bang-ds-phieu"}`}
                    data={dsPhieuNhapKho}
                    columns={DanhSachPhieuChungColumns}
                    isHiddenCheckall={true}
                    verticalScroll={true}
                    selectionMode={SELECTION_MODE.MULTI}
                    onCheckboxChange={handlerPrintPhieu}
                    rowSelected={dsPhieuIn}
                  />
                  <TablePagination
                    handlePagesChange={handlePagesChange}
                    handleRowsPerPageChange={handleRowsPerPageChange}
                    rowsPerPage={rowsPerPage}
                    rowsForPage={rowsForPage}
                    page={page}
                    setPage={setPage}
                    setRowsPerPage={setRowsPerPage}
                    totalPages={Number(configTable.totalPages)}
                    totalElements={configTable.totalElements}
                    numberOfElements={configTable.numberOfElements}
                    hideTotalElements
                    // customComponent={
                    //   <WfStatusSummary col={2} summaryStatus={summaryStatus} />
                    // }
                    className="border border-0"
                    customComponentClassName="spaces min-w-900px"
                  />
                </div>
              </div>
            </div>
          </div>

        </div>

      </div>

    </div>
  )
}

export default withBarcodeScan(FormXuatKho);
